import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Result } from '@/reservation/reservation.model';
import { Product } from './sections.model';

@Injectable({
	providedIn: 'root',
})
export class SectionsApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getProducts(name = '', query = ''): Observable<Result<Product>> {
		return this.httpClient.get<Result<Product>>(`${this.apiUrl}/product/?name__icontains=${name}${query}`);
	}
}
